import { Icon, type IconTone } from './Icon';

/**
 * История анкеты: часы со стрелкой назад.
 *
 * Фигура взята из набора lucide (ISC) и посажена на нашу обвязку: своя дуга
 * со стрелкой выходила кривой — остриё заворачивалось не в ту сторону.
 * Коробка у неё родная, 24: при выводе на 13 px линия в 2 даёт те же 1.08 на
 * экране, что и наши 1.1 в коробке 14.
 *
 * От `ClockIcon` (срок действия способности) отличается разомкнутым кругом со
 * стрелкой — и отличается заметно.
 */
export function HistoryIcon({ size, tone }: { size?: number; tone?: IconTone }) {
  return (
    <Icon size={size} box={24} strokeWidth={2} tone={tone}>
      <path d="M3 12a9 9 0 1 0 9-9 9.75 9.75 0 0 0-6.74 2.74L3 8" />
      <path d="M3 3v5h5" />
      <path d="M12 7v5l4 2" />
    </Icon>
  );
}
